$('#product-slider').owlCarousel({
            margin: 10,
            nav: true,
            loop: true,
            navText: ["<img src='https://cdn.shopify.com/s/files/1/0670/3434/9859/files/left_arrow.png?v=1671977183'>","<img src='https://cdn.shopify.com/s/files/1/0670/3434/9859/files/right_arrow.png?v=1671977183'>"],
            rtl: false,
                  autoplay:true,
                autoplayTimeout:3000,
                autoplayHoverPause:true,
               
                dots: false,
                dotsEach:true,
                responsiveClass:true,
            responsive: {
                0: {
                    items: 2
                },
                600: {
                    items: 3
                },
                1000: {
                    items: 4
                },
              2000: {
                    items: 5
                },
               2500: {
                    items: 6
                }
            }
        });

// $(document).ready(function(){
//             $(".owl-carousel").owlCarousel({
//                 nav:true,
//                 navContainer: '.owl-nav',
//                 navText: ["<img src='https://i.pinimg.com/originals/bf/e6/26/bfe626d92c27c4968becdc57bbf406b9.jpg'>","<img src='https://i.pinimg.com/originals/bf/e6/26/bfe626d92c27c4968becdc57bbf406b9.jpg'>"],
//                 rtl: false,
//                 loop:true,
                
              
//                 autoplay:true,
//                 autoplayTimeout:3000,
//                 autoplayHoverPause:true,
               
//                 dots: true,
//                 dotsEach:true,
//                 responsiveClass:true,
//                 responsive:{
//                     0:{
//                         items:1,
//                         // nav:true
//                     },
//                     600:{
//                         items:3,
                        
                       
//                     },
//                     1000:{
//                         items:5,
//                         // nav:true,
                        
//                     }
//                 }
//             });
//         });